import wpService from '../../../services/wordpress.js'

const QA_TYPE = 'worker'
export default {
  async getQuestionAnswers({ commit }) {
    try {
      commit('SET_QUESTION_ANSWER_LOADING', true)
      const res = await wpService.getQuestionAnswer(QA_TYPE)

      if (res.data.status) {
        commit('FETCH_QUESTION_ANSWERS', res.data.data)
      }
    } catch (e) {
      commit('FETCH_QUESTION_ANSWERS', [])
    }
    commit('SET_QUESTION_ANSWER_LOADING', false)
  }
}
